import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Archive } from "../../../@types/archive";
const createArchive = createAsyncThunk(
  "paymentNoticeDetail/createArchive",
  async (file: any, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(`${api.baseURL}archive`, {
        method: "POST",
        body: formData,
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data: Archive = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default createArchive;
